// extracted by mini-css-extract-plugin
export var askAiIcon = "_s2-9";
export var container = "_s2-0";
export var groupSeparator = "_s2-a";
export var highlight = "_s2-4";
export var resultIcon = "_s2-5";
export var resultItem = "_s2-7";
export var resultSubtitle = "_s2-3";
export var resultTitle = "_s2-2";
export var resultsList = "_s2-1";
export var searchGroup = "_s2-6";
export var selected = "_s2-8";